(()=>{'use strict';
const C=window.SDPC;if(!C||C.pageReady)return;C.pageReady=true;
const{$,$$,openDrawer}=C;
let revealObserver=null;
const initReveal=(scope=document)=>{
  if(!document.body.classList.contains('sd-reveal-enabled')||!('IntersectionObserver'in window))return;
  if(!revealObserver)revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target)}
  }),{threshold:.08});
  const items=[];
  if(scope.matches?.('[data-reveal]'))items.push(scope);
  items.push(...$$('[data-reveal]',scope));
  items.forEach(el=>{if(!el.classList.contains('is-visible'))revealObserver.observe(el)});
};

document.addEventListener('click',e=>{
  const filters=e.target.closest('[data-open-filters]');
  if(filters){e.preventDefault();e.stopImmediatePropagation();openDrawer('filters');return}
  const view=e.target.closest('[data-view-columns]');
  if(view){
    e.preventDefault();
    const grid=$('[data-collection-grid]');if(!grid)return;
    grid.style.setProperty('--desktop-columns',view.dataset.viewColumns);
    $$('[data-view-columns]').forEach(el=>el.classList.remove('is-active'));
    view.classList.add('is-active');
  }
},true);

const boot=()=>initReveal(document);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',e=>setTimeout(()=>initReveal(e.target),0));
})();
